import { render } from "./UploadedImagePreview.vue?vue&type=template&id=12804780&lang=true"
import script from "./UploadedImagePreview.vue?vue&type=script&lang=js"
export * from "./UploadedImagePreview.vue?vue&type=script&lang=js"
script.render = render

export default script